import effectManager from '../effect';
import webglManager from './webgl';
import panelManager from './panel';
import movieManager from './movie';
import updateManager from './update';
import developmentManager from '../../page/development';

let _effect = new effectManager();
let _panel = new panelManager();
let _movie = new movieManager();
let _webgl = new webglManager();
let _update = new updateManager();
let _development = new developmentManager();

export default class scrollManager {

    constructor(){

        this.section = '';
        this.nowTarget = '';
        this.nextTarget = '';
        this.nowID = '';
        this.nextID = '';
        this.fadetext = '';
        this.splitText = '';
        this.cntShowTimer = '';
        this.screenType = '';

        this.header = $("#l-header");
        this.footer = $('#l-footer__social');
        this.movieBg = $('#c-movie-bg');
        this.movieiot1 = $('#c-movie-bg__iot1');
        this.movieiot2 = $('#c-movie-bg__iot2');
        this.movieDigitaltwin = $('#c-movie-bg__digital-twin');
        this.technologyFigure = $('#l-technology__figure');
        this.developerTitle = $('#l-developer__title');
        this.developerList = $('#l-developer__list');
        this.panelSquare = $('.js__panel-square');
        this.canvas = $('#js__canvas');

        this.current = '.js__current';

    }

    normalScrollPrev(_status){

        let _this = this;

        if(_status.footerFlg){ //footer
            _this.footerMotion(_status,'hide');
        }else{ //normal
            if (_status.nextcurrent <= 0) return false;
            _status.nextcurrent--;
            _this.normal(_status);
        }

    }
    normalScrollNext(_status,_sectionMax){

        let _this = this;

        if(_status.id === 'l-contact'){ //footer
            _this.footerMotion(_status,'show');
        }else{ //normal
            if (_status.nextcurrent >= _sectionMax) return false;
            _status.nextcurrent++;
            _this.normal(_status);
        }

    }

    /* -----------------------------------------------

     -- normal

     -------------------------------------------------- */

    normal(_status) {

        this.section = $(".js__section");
        this.nowTarget = $('#'+_status.id);
        this.nextTarget = this.section.eq(_status.nextcurrent);
        this.nowID = this.nowTarget.attr('id');
        this.nextID = this.section.eq(_status.nextcurrent).attr('id');
        this.splitText = this.nextTarget.find('.js__split-text');
        this.fadeContent = this.nextTarget.find('.js__content-fade');
        if(Useragnt.mobile){
            this.screenType = this.nextTarget.data('screen_sp');
        }else{
            this.screenType = this.nextTarget.data('screen_pc');
        }

        this.movieiot1 = $('#c-movie-bg__iot1');
        this.movieiot2 = $('#c-movie-bg__iot2');
        this.movieDigitaltwin = $('#c-movie-bg__digital-twin');

        this.hide(_status);

    }

    /* -----------------------------------------------

     -- hide

     -------------------------------------------------- */

    hide(_status) {

        let _this = this;

        _status.Flg = true;

        //set
        clearTimeout(_this.cntShowTimer);

        $("#c-scroll").removeClass("is-show");

        if(!_status.webglplay){
            _webgl.startstop(_status); //再開
        }

        /* -----------------------------------------------
         -- visual
         -------------------------------------------------- */

        if(_this.nextID !== 'l-main-copy'){
            let h = $('.headerglobalnavi').height()+20;
            TweenMax.killTweensOf($('.headerglobalnavi'));
            TweenMax.to($('.headerglobalnavi'), .45, {
                y:-h,
                easing:Expo.easeOut
            });
            TweenMax.to(_this.header, .38, {
                delay:1.2,
                opacity:1,
                y:0,
                ease: Power4.easeOut
            });
            TweenMax.staggerTo(_this.footer.children(), .18, {
                delay:1.2,
                opacity:1,
                x:0,
                y:0,
                ease: Power4.easeOut
            },.12);
        }

        /* -----------------------------------------------
         -- movie
         -------------------------------------------------- */

        if(_this.nextID !== 'l-iot' && _status.loading){
            if(!Useragnt.mobile){
                let _movieBg1 = _this.movieiot1.get(0);
                let _movieBg2 = _this.movieiot2.get(0);
                _movieBg1.pause();
                _movieBg2.pause();
                TweenMax.to([_this.movieBg,_this.movieiot1,_this.movieiot2], .45, {
                    autoAlpha: 0,
                    display:'none',
                    easing:Expo.easeOut
                });
            }
        }else if(_this.nextID !== 'l-digital-twin' && _status.loading){
            if(!Useragnt.mobile){
                let _movieBg = _this.movieDigitaltwin.get(0);
                _movieBg.pause();
                TweenMax.to([_this.movieBg,_this.movieDigitaltwin], .45, {
                    autoAlpha: 0,
                    display:'none',
                    easing:Expo.easeOut
                });
            }
        }

        /* -----------------------------------------------
         -- technology
         -------------------------------------------------- */
        if(_this.nowID === 'l-technology') {

            TweenMax.to(_this.technologyFigure, .45, {
                autoAlpha: 0,
                display: 'none',
                easing: Expo.easeOut
            });
            TweenMax.to(_this.technologyFigure.find('img'), .45, {
                y: '-50px',
                autoAlpha: 0,
                display: 'none',
                easing: Expo.easeOut
            });
        }

        /* -----------------------------------------------
         -- development
         -------------------------------------------------- */
        if(_this.nowID === 'l-development') {

            _development.set('hide');
            _effect.developmentMotion(_status,_this.nowTarget,'hide');
            setTimeout(function () {
                _panel.hide(_status,_this);
            }, 450);

        /* -----------------------------------------------
         -- developer
         -------------------------------------------------- */
        }else if(_this.nowID === 'l-developer') {

            // motion
            TweenMax.to([_this.developerTitle,_this.developerList], .45, {
                y: '-10px',
                autoAlpha: 0,
                display: 'none',
                easing: Expo.easeOut,
                // onComplete: function () {
                //     _this.show(_status);
                // }
            });
            _effect.developerMotion(_this.nowTarget, 'hide');
            setTimeout(function () {
                TweenMax.to(_this.section.filter(_this.current), .45, {
                    autoAlpha: 0,
                    display: 'none',
                    easing: Expo.easeOut
                });
                _this.section.filter(_this.current).removeClass("js__current");
                _this.panelSquare.removeClass("is-done");
                _panel.show(_status, _this);
            }, 300);

        /* -----------------------------------------------
         -- contact
         -------------------------------------------------- */
        } else if (_this.nowID === 'l-contact') {
            _effect.contactMotion(_status,_this.nowTarget, 'hide');
            setTimeout(function () {
                _panel.hide(_status,_this);
            }, 300);

        /* -----------------------------------------------
         -- normal
         -------------------------------------------------- */
        }else if (_this.nowTarget.find('.js__split-text')[0]) {

            //motion
            _this.nowTarget.find('.l-section__title').find('.line').removeClass('is-done').addClass('is-hide');

            if(Useragnt.mobile) {

                if (_this.nowTarget.find('.js__content-fade')[0]) {
                    _effect.contentMotionSP(_this.nowTarget, 'hide');
                } else {
                    _effect.textMotion(_this.nowTarget.find('.js__split-text'), 'hide', _this.nowID);
                }

            }else{
                _effect.textMotion(_this.nowTarget.find('.js__split-text'),'hide',_this.nowID);

                if(_this.nowTarget.find('.js__content-fade')[0]){
                    _effect.contentMotion(_this.nowTarget.find('.js__content-fade'),'hide',_this.nowID);
                }
            }

            setTimeout(function () {
                _panel.hide(_status,_this);
            }, 300);

        }else{
            _panel.hide(_status,_this);
        }

    }

    /* -----------------------------------------------

     -- show

     -------------------------------------------------- */

    show(_status) {

        let _this = this;

        _webgl.update(_status);

        $('html,body').animate({scrollTop: 0}, '1');

        TweenMax.to(_this.nextTarget, .45, {
            autoAlpha: 1,
            display:'block',
            easing:Expo.easeOut
        });

        _this.nextTarget.addClass("js__current");

        _status.id = _this.nextID;
        let _delay = 750;
        let _linedelay = 350;
        if(window.innerWidth < 750){
            _delay = 800;
        }
        if (!_status.loading) {
            _delay = 3e3;
        }

        TweenMax.to(_this.canvas, .68, {
            delay:3,
            opacity:1,
            easing:Expo.easeOut
        });

        /* -----------------------------------------------
         -- technology
         -------------------------------------------------- */

        if (_this.nextID === 'l-technology') {
            TweenMax.fromTo(_this.technologyFigure, .45, {
                autoAlpha: 0,
                display:'none',
            },{
                autoAlpha: 1,
                display:'block',
                easing:Expo.easeOut
            });
            TweenMax.fromTo(_this.technologyFigure.find('img'), .45, {
                y: '50px',
                autoAlpha: 0,
                display:'none',
            },{
                y:0,
                autoAlpha: 1,
                display:'block',
                easing:Expo.easeOut
            });
        }

        /* -----------------------------------------------
         -- movie
         -------------------------------------------------- */

        else if(_this.nextID === 'l-iot' || _this.nextID === 'l-digital-twin'){

            if(!Useragnt.mobile){
                _delay = 2300;
                _movie.bgPlay(_status,_this.nextID);
            }
        }

        /* -----------------------------------------------
         -- development
         -------------------------------------------------- */
        else if(_this.nextID === 'l-development') {

            _delay = 1400;
            _effect.developmentMotion(_status,_this.nextTarget,'show');
            _development.set('show');

        }

        /* -----------------------------------------------
         -- developer
         -------------------------------------------------- */

        if (_this.nextID === 'l-developer') {
            _delay = 1500;
            TweenMax.fromTo([_this.developerTitle,_this.developerList], .45, {
                y: '-10px',
                autoAlpha: 0,
            },{
                y:0,
                autoAlpha: 1,
                display:'block',
                easing:Expo.easeOut
            });
            _effect.developerMotion(_status,_this.nextTarget, 'show');

        /* -----------------------------------------------
         -- contact
         -------------------------------------------------- */
        } else if (_this.nextID === 'l-contact') {

            _effect.contactMotion(_status,_this.nextTarget, 'show');

        /* -----------------------------------------------
         -- text motion
         -------------------------------------------------- */
        } else if (_this.splitText[0]) {

            //set
            _this.nextTarget.find('.line').removeClass('is-hide is-done');

            if(Useragnt.mobile){

                if(_this.fadeContent[0]){
                    _effect.contentMotionSP(_this.nextTarget,'show');
                    _linedelay = 1200;
                }else{
                    _effect.textMotion(_this.splitText,'show',_this.nextID);
                    _linedelay = 350;
                }

            }else{
                _effect.textMotion(_this.splitText,'show',_this.nextID);
                if(_this.fadeContent[0]){
                    _effect.contentMotion(_this.fadeContent,'show',_this.nextID);
                }
                if($('html.ie')[0] || $('html.edge')[0]){
                    _linedelay = 350;
                }else{
                    _linedelay = _this.splitText.eq(2).children().children().length * 7;
                }
            }

            setTimeout(function () {
                _this.nextTarget.find('.l-section__title').find('.line').addClass('is-done');
            }, _linedelay);
        }

        // status update
        clearTimeout(_this.cntShowTimer);
        _this.cntShowTimer = setTimeout(function () {
            if(_this.nextID === 'l-main-copy'){
                let h = $('.headerglobalnavi').height();
                TweenMax.to($('.headerglobalnavi'), .45, {
                    y:0,
                    easing:Expo.easeOut
                });
            }else{
                if(Useragnt.mobile){
                    TweenMax.to($('#c-pager__trigger'), .38, {
                        delay:.2,
                        opacity:1,
                        y:0,
                        ease: Power4.easeOut
                    });
                }
            }
            _update.screen(_status,_this.screenType);
            _status.Flg = false;
        }, _delay);

    }

    /* -----------------------------------------------

     -- footer

     -------------------------------------------------- */

    footerMotion(_status,_type) {

        let $footer = $('.moreOnDenso.baseComponentStructure,.footer.baseComponentStructure');

        let _this = this;

        _status.Flg = true;

        switch (_type) {
            case 'hide': // --------------- hide --------------- //

                $("html").removeClass('is-footer-show');

                TweenMax.to($footer, .48, {
                    y:window.innerHeight,
                    easing:Expo.easeOut,
                    onComplete:function(){
                        $("#c-scroll").addClass("is-done is-show");
                        $footer.removeClass('is-show');
                        _status.scroll = false;
                        _status.Flg = false;
                        _status.footerFlg = false;
                        _this.screenType = 'full';
                        _update.screen(_status,_this.screenType);
                    }
                });

                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                if($footer.hasClass("is-show")||_status.scroll) return;

                _status.footerFlg = true;

                // set
                TweenLite.set($footer, {
                    y:window.innerHeight,
                });

                // motion
                $("#c-scroll").removeClass("is-done is-show");
                $footer.addClass('is-show');
                $("html").addClass('is-footer-show');
                setTimeout(function () {
                    $("html").addClass('is-footer-show');
                }, 500);

                let y = ($footer.innerHeight>window.innerHeight)?0:window.innerHeight-$footer.innerHeight;

                TweenMax.to($footer, .48, {
                    y:y,
                    delay:0.1,
                    easing:Expo.easeOut,
                    onComplete:function(){
                        _status.scroll = true;
                        _status.Flg = false;
                        _this.screenType = 'scroll';
                        _status.scrollStart = true;
                        _status.scrollEnd = false;
                        $('html').removeClass('full-screen').addClass('scroll-screen');
                    }
                });

                break; // --------------- show (end) --------------- //
        }
    }
}
